<template>
    <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.33331 1H22.6666M1.33331 9H22.6666M13.3333 17H22.6666" stroke="#4A4A49" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>